import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UsersPage from '@features/admin/users/UsersPage.tsx';
import { useCreateAdminUserStore } from '@features/admin/users/useAdminUserStore.ts';

const adminUsersSearchSchema = z.object({
  q: z.string().optional(),
  organizationId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(10),
});

export type AdminUsersSearch = z.infer<typeof adminUsersSearchSchema>;

export const Route = createFileRoute('/admin/users/')({
  validateSearch: search => adminUsersSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { q, organizationId, page, size } = ctx.search;
    useCreateAdminUserStore.getState().loadUsers({
      q,
      organizationId,
      page: page || 1,
      size: size || 10,
    });
  },
});

function RouteComponent() {
  return <UsersPage />;
}
